import { useEffect, useState } from "react";

const useUserProfile = () => {
  const [user, setUser] = useState(() =>
    JSON.parse(localStorage.getItem("UserDetails"))
  );

  useEffect(() => {
    const handleProfileUpdate = (event) => {
      setUser(event.detail);
    };

    window.addEventListener("profile-updated", handleProfileUpdate);

    return () => {
      window.removeEventListener("profile-updated", handleProfileUpdate);
    };
  }, []);

  const name = user
    ? `${user.first_name || ""} ${user.last_name || ""}`
    : "User";

  const role = user?.Designation || "Employee";

  const photo = user?.User_Photo || null;

  return { name, role, photo, user };
};

export default useUserProfile;